// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"ba24ea2b","213":"17ee27fd","453":"a0611200","610":"28ddce1e","732":"769ba9ce"}[chunkId] + ".chunk.js";
};